import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { cssMap } from '@compiled/react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const i18n = defineMessages({
	newLozenge: {
		id: 'feed.meetings.pill.new-lozenge',
		defaultMessage: 'New',
		description:
			'Label on a small "New" badge shown next to the Meetings pill on the For You page to highlight it as a new feature',
	},
});

const styles = cssMap({
	lozenge: {
		display: 'inline-flex',
		alignItems: 'center',
		marginLeft: token('space.100'),
		paddingInline: token('space.050'),
		height: '16px',
		borderRadius: token('radius.small'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border.discovery'),
		backgroundColor: token('color.background.neutral.subtle'),
		color: token('color.text'),
		font: token('font.body.small'),
		fontWeight: token('font.weight.medium'),
		// The visible label is "New" (accessible to screen readers); design requires
		// the badge to display in uppercase, matching the ADS discovery lozenge style.
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- design requirement; accessible label remains "New"
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
	},
});

/**
 * The "New" badge rendered next to the Meetings pill title.
 * Outlined discovery style (transparent fill, purple border) per design.
 * Visibility is decided by the caller (see useMeetingsPillNewLozenge).
 */
export const MeetingsPillNewLozenge = (): JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Box as="span" xcss={styles.lozenge}>
			{formatMessage(i18n.newLozenge)}
		</Box>
	);
};
